import { render, staticRenderFns } from "./storePersonList.vue?vue&type=template&id=15c1be46&scoped=true&"
import script from "./storePersonList.vue?vue&type=script&lang=js&"
export * from "./storePersonList.vue?vue&type=script&lang=js&"
import style0 from "./storePersonList.vue?vue&type=style&index=0&id=15c1be46&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15c1be46",
  null
  
)

export default component.exports